import React from 'react'
import * as yup from 'yup'
import { 
	withFormik,
} from 'formik'
import merge from 'lodash/merge'

import UseToast from '@connects/toast'
import UseSingular from '@connects/singular'
import Singular from './Singular'
import { cleanData } from '@utils/data';

const configSchema = yup.object().shape({
	// TODO: move these into validator presets
	formConfig: yup.mixed(),
	renderForm: yup.mixed(),
	resource: yup.string(), // TODO: validate using available resource
	connect: yup.mixed(),
	validationSchema: yup.mixed().required('config.validationSchema is required'),
})

export default function createSingularContainer(config) {

	// validate config
	config = configSchema.validateSync(config)

	const UseData = config.connect || UseSingular(config.resource);

	// Create decorated container
	@UseData
	@UseToast()
	@withFormik({
		mapPropsToValues: config.mapPropsToValues
			?	config.mapPropsToValues
			: props => {
				var data = props.data;

			// console.log('>>>>>>>>>>>', typeof )
				// TODO: figure out why removing this Object.keys check causes mapToCSVData function to error
				if(config.defaultValues && data && Object.keys(data).length) {
					data = merge({}, config.defaultValues, data);
				}
				return data;
			},
		validateOnBlur: false,
		validateOnChange: true,
		validationSchema: config.validationSchema,
		enableReinitialize: true,
		handleSubmit: async (values, { props, setSubmitting, resetForm, ...other }) => {

			// TODO: keep values that are now empty but weren't to begin with i.e. are empty in values but not in props.data
			// ^ perhaps in this scenario convert empty values to null/undefined to ensure mongoose overwrites old values with newly empty value rather than saving empty string
			const cleanedValues = cleanData(values);

			props.match.params.id === 'new'
			  ? await props.actions.create(cleanedValues)
				: await props.actions.update(props.data.id, cleanedValues);

			await setSubmitting(false);
			await resetForm();

		}
	})
	class SingularContainer extends React.Component {

		// Lifecycle

		componentDidMount() {
			const { isNew, actions } = this.props;
			isNew
				? actions.new()
				: actions.get(this.props.match.params.id);
		}
		
		// Render 
		
		render() {
			const SingularComponent = config.component ? config.component : Singular;
			return <SingularComponent 
				{...config}
				{...this.props} 
			/>
		}

	}

	return SingularContainer;

}


// WEBPACK FOOTER //
// ./src/components/Singular/createSingularContainer.jsx